import { useState, useEffect } from "react";

/**
 * Debounce a value by `delay` ms.
 * Returns the debounced value that only updates after the input stops changing.
 *
 * @param {*} value - value to debounce
 * @param {number} [delay=300] - debounce delay in ms
 * @returns {*} debounced value
 */
export default function useDebounce(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
